<template>
    <div>
        <nav class="pagination-wrap d-inline-block mt-15" aria-label="">
            <ul class="pagination" role="navigation">
                <li class="page-item" :class="{ disabled : current_page == 1}">
                    <a href="#" @click.prevent="decrementPage" class="d-block">
                        <span class="page-link" aria-hidden="true">&lsaquo; Vorherige</span>
                    </a>
                </li>
                <li v-for="link in page_count" class="page-item" :class="{active : current_page == link}">
                    <a href="#" @click.prevent="jumpToPage(link)" class="d-block">
                    <span class="page-link">{{link}}</span>
                    </a>
                </li>
                <li class="page-item" :class="{ disabled : current_page == page_count}" aria-label="Nächste">
                    <a href="#" @click.prevent="incrementPage" class="d-block"><span class="page-link">Nächste &rsaquo;</span></a>
                </li>
            </ul>
        </nav>
    </div>
</template>

<script>

    // ***********  Localization ***************
    import Lang from 'lang.js'

    // get the data source
    import translations from '../../vue-translations.js';

    //Bsp.: lang.get('auth.btn_login'));

    // ***********  Localization ***************

    export default {
        props: ['signed_api_get_table_route','page_in'],
        components: {},
        data() {
            return {
                queryValue: {
                    search_str: null,
                    aufgabe_typ: null,
                    postfach: null,
                    zeitraum_von: null,
                    zeitraum_bis: null,
                    id_status: null,
                    id_user_von:null,
                    wiederkehrend: null,
                    delegiert: null,
                    page: this.page_in
                },
                item_count: null,
                current_page: null,
                per_page: null,
                lang: null,
            };
        },
        created() {
            var lang = new Lang();

            lang.setLocale(this.locale_in);

            if (lang.getLocale() === 'undefined') {
                lang.setLocale('de');
            }
            lang.setMessages(translations);
            this.lang = lang;

            let self = this;
            this.$eventBus.$on('aufgabenSearchQuery', function (queryValue) {
                self.queryValue = queryValue;
                self.getData()
                self.setStoreData();
            });

        },
        mounted() {
            this.getData();
        },
        watch: {},
        computed: {
            page_count(){
                return (this.item_count && this.per_page)? Math.ceil( this.item_count / this.per_page) : 0;
            }
        },
        methods: {
            getData() {
                $("#cover-spin").show();
                let self = this;
                axios.post(this.signed_api_get_table_route, {
                    search_str: this.queryValue['volltextsuche'],
                    aufgabe_typ: this.queryValue['aufgabe_typ'],
                    postfach: this.queryValue['postfach'],
                    zeitraum_von: this.queryValue['zeitraum_von'],
                    zeitraum_bis: this.queryValue['zeitraum_bis'],
                    id_status: this.queryValue['id_status'],
                    id_user_von: this.queryValue['id_user_von'],
                    wiederkehrend: this.queryValue['switch_wiederkehrend'],
                    delegiert: this.queryValue['switch_delegiert'],
                    ausgeblendet: this.queryValue['switch_ausgeblendet'],
                    page: this.queryValue['page'] ? this.queryValue['page'] : this.current_page,
                })
                    .then(function (res) {
                        $("#mainTable").html(res.data);

                        setTimeout( function(){
                            self.item_count = parseInt($("#count").val());
                            self.current_page = parseInt($("#current_page").val());
                            self.per_page = parseInt($("#per_page").val());
                            $("#cover-spin").hide();

                        }, 100);
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            triggerSearchEvent() {
                this.$eventBus.$emit('aufgabenSearchQuery', {
                    search_str: this.queryValue['volltextsuche'],
                    aufgabe_typ: this.queryValue['aufgabe_typ'],
                    postfach: this.queryValue['postfach'],
                    zeitraum_von: this.queryValue['zeitraum_von'],
                    zeitraum_bis: this.queryValue['zeitraum_bis'],
                    id_status: this.queryValue['id_status'],
                    id_user_von: this.queryValue['id_user_von'],
                    wiederkehrend: this.queryValue['switch_wiederkehrend'],
                    delegiert: this.queryValue['switch_delegiert'],
                    page: this.current_page,
                });
            },
            incrementPage(){
                this.current_page = (this.current_page < this.page_count) ? parseInt(this.current_page) + 1 : this.page_count;
                this.triggerSearchEvent();
            },
            decrementPage(){
                this.current_page = (this.current_page > 1) ? parseInt(this.current_page) - 1 : 1;
                this.triggerSearchEvent();
            },
            jumpToPage(page){
                this.current_page = page;
                this.triggerSearchEvent();
            },
            setStoreData(){
                this.$store.$store.commit('storeQueryAufgaben', this.queryValue);
            },
        }
    };
</script>
<style scoped>
</style>
